class enquiryModal {
  /*
  * constructor
  */
  constructor() {
    this.clickElement = document.querySelector('.c-enquiryBlock__btn');
    this.closeElement = document.querySelector('.c-enquiryModal__close');
    this.showHideElement = document.querySelector('.c-enquiryModal');
    this.bodyEl = document.body;

    if (this.showHideElement !== null && this.clickElement !== null) {
        this.clickElement.addEventListener('click', (e) => {
          e.preventDefault();
          if (this.showHideElement.classList.contains('c-enquiryModal--is-open')) {
            this.showHideElement.classList.remove('c-enquiryModal--is-open');
          } else {
            this.showHideElement.classList.add('c-enquiryModal--is-open');
          }
        });

        if (this.closeElement !== null) {
          this.closeElement.addEventListener('click', () => {
            this.showHideElement.classList.remove('c-enquiryModal--is-open');
          });
        }
    }
  }
}
module.exports = enquiryModal;
